export default __webpack_public_path__ + "438c64b23f99c338ea8882dfc31b6b32.svg";